<template>
  <div class="access-message">
    <i class="icofont-warning"></i>
    <h1>Acesso Negado</h1>
    <div class="info-user" v-html="infoUser"></div>
    <p>
      Sua lotação, aparentemente, não está ativa no PEC ou Centralizador. Você
      está conseguindo acessar o Prontuário Eletrônico com seu CPF e senha?
    </p>
    <router-link to="/login">Voltar para o início</router-link>
  </div>
</template>

<script>
import { jwtDecode } from 'jwt-decode'

export default {
  name: 'AcessoNegado',
  data() {
    return {}
  },
  computed: {
    infoUser() {
      const decoded = jwtDecode(this.$store.state.accessToken)
      return `<h3>${this.$store.state.username}</h3><h4>${this.$store.state.cidade}</h4><h4>${decoded.funcao}</h4>`
    },
  },
}
</script>

<style>
.access-message {
  background-color: #fff;
  padding: 25px;
  box-shadow: 0 3px 10px rgba(62, 85, 120, 0.045);
  border-radius: 1rem;
  background-color: #fff;
  border: 1px solid #deebfd;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.access-message i {
  font-size: 80px;
}

.access-message a {
  border: 1px solid;
  padding: 10px 20px;
  border-radius: 50px;
  text-transform: uppercase;
  display: inline-block;
  margin-top: 10px;
  font-size: 20px;
}

/*
    ##Device = Most of the Smartphones Mobiles (Portrait)
    ##Screen = B/w 320px to 479px
    */

@media (min-width: 320px) and (max-width: 480px) {
  .access-message {
    width: 300px;
  }
  .access-message h1 {
    font-size: 30px;
  }
  .access-message a {
    font-size: 16px;
  }
}

/*
    ##Device = Tablets, Ipads (portrait)
    ##Screen = B/w 768px to 1024px
    */

@media (min-width: 768px) and (max-width: 1024px) {
  .access-message {
    width: 500px;
  }
}
</style>
